export default __webpack_public_path__ + "images/assets/78a548f00c97a2071585a0aa20cf1824.svg";